import React from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const Header = () => {
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" style={{ flexGrow: 1 }}>
          SSglobalmart.com
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
